var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSLetter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sLet",
    width: 41,
    height: 49,
    viewBox: "0 0 41 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.789307 43.2534L4.28853 36.5831C8.34026 39.3624 14.602 41.4005 20.6796 41.4005C28.5989 41.4005 31.7298 38.9918 31.7298 34.9155C31.7298 24.3542 2.07849 33.4332 2.07849 14.7193C2.07849 6.19619 9.62945 0.637604 21.6005 0.637604C27.6781 0.637604 34.6765 2.30518 38.7282 4.89918L35.0448 11.5695C30.8089 8.79019 26.2047 7.86376 21.6005 7.86376C14.2337 7.86376 10.5503 10.6431 10.5503 14.3488C10.5503 25.4659 40.2016 16.3869 40.2016 34.7302C40.2016 43.2534 32.4665 48.6267 19.9429 48.6267C12.392 48.812 4.65687 46.4033 0.789307 43.2534Z",
    fill: "#FF6060"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSLetter);
export default __webpack_public_path__ + "static/media/sLetter.5fbe214e07d32c7968ffd738d7805d82.svg";
export { ForwardRef as ReactComponent };